
    $(".productSeriesDiv").hover(function (){
        var index = $(this).attr('data-index');
        $("#productSeriesImg-"+index).css('opacity','0');
        $("#productSeriesHoverImg-"+index).css('opacity','1');
        let productSeriesHeading = $("#productSeriesHeading-"+index);
        let productSeriesDec = $("#productSeriesDec-"+index);
        productSeriesHeading.css('color','#FFFFFF');
        productSeriesDec.css('color','#FFFFFF');
        // text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.50);
        productSeriesHeading.css('text-shadow','0 0.2rem 0.2rem rgba(0, 0, 0, 0.50)');
        // text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.50);
        productSeriesDec.css('text-shadow','0 0.1rem 0.3rem rgba(0, 0, 0, 0.50)');
    },function (){
        var index = $(this).attr('data-index');
        $("#productSeriesImg-"+index).css('opacity','1');
        $("#productSeriesHoverImg-"+index).css('opacity','0');
        let productSeriesHeading = $("#productSeriesHeading-"+index);
        let productSeriesDec = $("#productSeriesDec-"+index);
        productSeriesHeading.css('color','#111111');
        productSeriesDec.css('color','#111111');
        // text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.50);
        productSeriesHeading.css('text-shadow','none');
        // text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.50);
        productSeriesDec.css('text-shadow','none');
    })